import { render, staticRenderFns } from "./DocumentStatus.vue?vue&type=template&id=21a88682&scoped=true&"
import script from "./DocumentStatus.vue?vue&type=script&lang=js&"
export * from "./DocumentStatus.vue?vue&type=script&lang=js&"
import style0 from "./DocumentStatus.vue?vue&type=style&index=0&id=21a88682&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a88682",
  null
  
)

export default component.exports